import charteredService from '@/api/chartered'
import { CHARTERED } from '../types'

export default {
  namespaced: true,
  state: {
    charteredBuses: [],
    charteredBusesName: [],
    sites: [],
  },
  getters: {
    charteredBusesName: (state) => {
      return state.charteredBusesName
    },
  },
  mutations: {
    [CHARTERED.AVAILABLE_CHARTERED_BUSES_SET](state, charteredBusesName) {
      state.charteredBusesName = charteredBusesName
    },
    [CHARTERED.SET_SITE](state, sites) {
      state.sites = sites
    }
  },
  actions: {
    async getAvailableCharteredBuses({ commit }) {
      let response = await charteredService.getAvailableCharteredBuses()
      commit(CHARTERED.AVAILABLE_CHARTERED_BUSES_SET, response.data)
    }
  }
}
